import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { Programa } from 'src/app/core/programa';
import { Projeto } from 'src/app/core/projeto';
import { Unidade } from 'src/app/core/unidade';
import { ToastService } from 'src/app/services/toast/toast.service';
import { PlanejamentoOficina } from '../../../core/planejamento-oficina';
import { PlanejamentoOficinaService } from '../../../services/planejamento-oficina/planejamento-oficina.service';

@Component({
  selector: 'cadastrar-planejamento-oficina',
  templateUrl: './cadastrar-planejamento-oficina.component.html',
  styleUrls: ['./cadastrar-planejamento-oficina.component.css']
})
export class CadastrarPlanejamentoOficinaComponent implements OnInit {

  planejamentoOficina: PlanejamentoOficina = new PlanejamentoOficina();


  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  mostrarBotaoCadastrar = true;
  mostrarBotaoAtualizar = true;

  isAtualizar = false;
  area: string;
  menu: string;
  constructor(
    private planejamentoOficinaService: PlanejamentoOficinaService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastService: ToastService) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    this.area = this.getArea();
    this.limpar();

    if (!this.perfilAcesso.insere) {
      this.mostrarBotaoCadastrar = false;
    }

    if (!this.perfilAcesso.altera) {
      this.mostrarBotaoAtualizar = false;
    }

    const id = this.activatedRoute.snapshot.queryParams.id ? this.activatedRoute.snapshot.queryParams.id : null;
    if (id) {
      this.isAtualizar = true;
      this.planejamentoOficinaService.getById(id).subscribe((planejamentoOficina: PlanejamentoOficina) => {
        this.planejamentoOficina = planejamentoOficina;
      });
    }
    
  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  mostrarBotaoLimpar() {
    if (this.isAtualizar) { return false; }
    if (!this.mostrarBotaoAtualizar) { return false; }
    if (!this.mostrarBotaoCadastrar) { return false; }

    return true;
  }


  cadastrar() {
      
    this.planejamentoOficinaService.cadastrar(this.planejamentoOficina).subscribe(() => {
      const rota = this.menu ? this.menu+'/oficinaturmas':'oficinaturmas';
      this.router.navigate([rota]);
      this.toastService.showSucesso('Planejamento de oficina cadastrado com sucesso!');
    });
  }

  limpar() {
    this.planejamentoOficina = new PlanejamentoOficina();
    this.planejamentoOficina.projeto = new Projeto();
    this.planejamentoOficina.programa = new Programa();
    this.planejamentoOficina.unidade = new Unidade();
    this.planejamentoOficina.area = this.area;
  }

  cancelar() {
    const rota = this.menu ? this.menu+'/oficinaturmas':'oficinaturmas';
    this.router.navigate([rota]);
  }


  atualizar() {
    this.planejamentoOficinaService.alterar(this.planejamentoOficina).subscribe(() => {
      const rota = this.menu ? this.menu+'/oficinaturmas':'oficinaturmas';
      this.router.navigate([rota]);
      this.toastService.showSucesso('Oficina atualizada com sucesso.');
    });

  }


}
